import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1);
const _hoisted_5 = {
  style: {
    "min-height": "100px"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_7 = {
  class: "row"
};
const _hoisted_8 = {
  class: "col-12 mb-3"
};
const _hoisted_9 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_10 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_11 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_12 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_14 = {
  key: 0,
  class: "row"
};
const _hoisted_15 = {
  class: "col-12 mb-3"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "待生效新 Worker ID")], -1);
const _hoisted_17 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_18 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_19 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_20 = {
  key: 1,
  class: "row"
};
const _hoisted_21 = {
  class: "col-12 mb-3"
};
const _hoisted_22 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_23 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_24 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_25 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_26 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_27 = {
  class: "row"
};
const _hoisted_28 = {
  key: 0,
  class: "col-12 mt-2"
};
const _hoisted_29 = {
  key: 2,
  class: "i-layer"
};
const _hoisted_30 = {
  class: "row"
};
const _hoisted_31 = {
  key: 0,
  class: "col-12 mb-3 mt-3"
};
const _hoisted_32 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2 justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_33 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_34 = {
  class: "d-flex align-items-center"
};
const _hoisted_35 = {
  key: 1,
  class: "col-12 mt-2"
};
const _hoisted_36 = {
  key: 2,
  class: "col-12 mb-2 mt-2"
};
const _hoisted_37 = {
  key: 3,
  class: "w-100 i-layer mb-2"
};
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_39 = {
  key: 4,
  class: "col-12 mt-2"
};
const _hoisted_40 = {
  key: 3,
  class: "mt-2 OffBoardingStep1"
};
const _hoisted_41 = {
  class: "row"
};
const _hoisted_42 = {
  class: "col-12"
};
const _hoisted_43 = {
  class: "i-layer mb-2"
};
const _hoisted_44 = {
  key: 0,
  class: "row mb-3 mt-3"
};
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Confirm Change Worker Address")], -1);
const _hoisted_46 = [_hoisted_45];
const _hoisted_47 = {
  key: 1,
  class: "row mb-3 mt-3"
};
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Change Worker")], -1);
const _hoisted_49 = [_hoisted_48];
const _hoisted_50 = {
  class: "row mt-3"
};
const _hoisted_51 = {
  class: "col-12"
};
const _hoisted_52 = {
  key: 2,
  class: "row mb-3 i-layer"
};
const _hoisted_53 = {
  class: "col-12 mb-1"
};
const _hoisted_54 = {
  key: 3,
  class: "row mt-4"
};
const _hoisted_55 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_evm_err_tip = _resolveComponent("evm-err-tip");
  const _component_Tip = _resolveComponent("Tip");
  const _component_SingerV2 = _resolveComponent("SingerV2");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [$data.showCurrentWorker ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('change.current')) + " Worker ID", 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.nodeInfo.worker), 1), !$data.isCopy && $options.nodeInfo.worker !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text",
    onClick: _cache[0] || (_cache[0] = $event => $options.copy($options.nodeInfo.worker)),
    style: {
      "font-size": "18px",
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_13, " copied ")) : _createCommentVNode("", true)])])]), $data.workerChangeEpoch > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString($data.waitNewOwner), 1), !$data.isCopy && $data.waitNewOwner !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text",
    onClick: _cache[1] || (_cache[1] = $event => $options.copy($data.waitNewOwner)),
    style: {
      "font-size": "18px",
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_19, " copied ")) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), $data.workerChangeEpoch > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('change.newTime')), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($options.getByBlockNumberToTime($data.workerChangeEpoch)), 1)])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.workerChangeEpoch > 0 && $data.needConfirmChangeWorkerAddress && !$data.affirmWorker ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [$data.needConfirmChangeWorkerAddress ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.confirmChangeWorker,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(" Confirm Change Worker ")]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.workerChangeEpoch < 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [$data.showNewWorker ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('change.new')) + " Worker ID", 1)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_input, {
    size: "large",
    disabled: $data.affirmWorker,
    style: {
      "height": "50px"
    },
    onKeyup: _withKeys($options.affirm, ["enter"]),
    onInput: $options.clearErr,
    modelValue: $data.newWorker,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.newWorker = $event),
    placeholder: _ctx.$t('change.workerInputTip')
  }, null, 8, ["disabled", "onKeyup", "onInput", "modelValue", "placeholder"])])])) : _createCommentVNode("", true), !$data.showNewWorker && !$data.affirmWorker ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.reapprove,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.change')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true), $data.isNewWorkerErr ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_evm_err_tip, null, {
    content: _withCtx(() => [_createTextVNode(_toDisplayString($data.newWorkerErrTips), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), !$data.isHaveActorId ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_Tip, {
    level: "error"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Actor Not Found')), 1), _hoisted_38, _createTextVNode(" " + _toDisplayString(_ctx.$t('Operator.You should recharge this address with some FIL')), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.showNewWorker && !$data.affirmWorker ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.affirm,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.affirmWorker ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [!$data.approvedProposalRes && $data.needConfirmChangeWorkerAddress ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46)) : _createCommentVNode("", true), !$data.approvedProposalRes && !$data.needConfirmChangeWorkerAddress ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_SingerV2, {
    ref: "singer",
    singerType: "approval",
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    "contract-a-b-i": $data.contractABI,
    "is-call-evm": false,
    "from-address": $data.fromAddress,
    "to-f0-address": $data.toF0Address,
    contractParams: $data.contractParams,
    onNext: $options.approvedProposal2
  }, null, 8, ["contract-method", "contract-a-b-i", "from-address", "to-f0-address", "contractParams", "onNext"])])]), !$data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), $data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('change.workerOk'),
    content: $data.needConfirmChangeWorkerAddress ? '' : _ctx.$t('change.workerOkWait'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "content", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)])), [[_directive_loading, $data.initLoading]])]);
}